export default __webpack_public_path__ + "static/media/gama_seguro-1.8a17775e.webp";